import React, { useState, useRef } from 'react'
import { MdOutlineEmail } from 'react-icons/md'
import { FaWhatsapp } from 'react-icons/fa';
import { BsFillArrowRightSquareFill } from 'react-icons/bs'
import { AiOutlineCheckCircle } from 'react-icons/ai'
import { motion } from 'framer-motion';

import { images } from '../../constants'
import { AppWrap, MotionWrap } from '../../wrapper'
import { client } from '../../client'
import './Contact.scss'

const Contact = () => {
  const [formData, setFormData] = useState({name: '', email: '', message: ''})
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    setLoading(true);

    const contact = {
      _type: 'contact',
      name,
      email,
      message
    }

    client.create(contact).then(() => {
      setLoading(false);
      setIsSubmitted(true);
      setFormData({name: "", email: "", message: ""})

      setTimeout(() => {setIsSubmitted(false)}, 4000)
    })
  }

  const pesan = () => {
    return (
      <>
        <motion.div
          transition={{ duration: .5, ease:'circInOut' }}
          className="message"
        >
          <p>You're message has been sent</p>
          <AiOutlineCheckCircle/>
        </motion.div>
      </>
    )
  }

  return (
    <>
      <div className="contact section">
        <span className="subtitle">Get In Touch</span>
        <h2 className="title">Contact Me</h2>
      </div>

      <div className='contact__container'>
        <div className="app__contact-cards">
          <h3 className="app__contact-title">Talk to me</h3>

          <div className="app__contact-card">
            <MdOutlineEmail/>
            <a href="mailto:muklasn20@gmail.com" className='p-text'>Email Me</a>

            <motion.div
              whileTap={{ scale: [1,.5] }}
            >
              <a href="mailto:muklasn20@gmail.com" className='p-text'><BsFillArrowRightSquareFill style={{ width: 18 }}/></a>
            </motion.div>
          </div>

          <div className="app__contact-card">
            <FaWhatsapp/>
            <a href="tel: 081318631593 " className='p-text'>Chat Me</a>

            <motion.div
              whileTap={{ scale: [1,.5] }}
            >
              <a href="tel: 081318631593 " className='p-text'><BsFillArrowRightSquareFill style={{ width: 18 }}/> </a>
            </motion.div>
          </div>
        </div>

        <form className="app__contact-form app__flex" onSubmit={handleSubmit}>
          <h3 className="app__contact-title">Send me a message</h3>

          <div className="app__flex">
            <input type="text" className="p-text" placeholder='Your Name' name="name" value={name} onChange={handleChangeInput} required />
          </div>

          <div className="app__flex">
            <input type="email" className="p-text" placeholder='Your Email' name="email" value={email} onChange={handleChangeInput} required />
          </div>

          <div>
            <textarea 
              name="message"
              placeholder='Your Message'
              value={message}
              onChange={handleChangeInput}
              className="p-text"
              required
            />
          </div>

          {!isSubmitted ? 
            (
              <>
              <div className='button'>
                <button 
                  type='submit' 
                  className="p-text" 
                  >
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
              </div>
              </>
            ) 
            : 
            (
              <>
                {pesan()}
                  
                <div className='button'>
                  <button 
                    type='submit' 
                    className="p-text" 
                  >
                    {loading ? 'Sending...' : 'Send Message'}
                  </button>
                </div>
              </>
            )
          }
        </form> 
      </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(Contact, 'app__contact'),
  'contact',
  'app__whitebg'
)